export default __webpack_public_path__ + "static/2-9e68cfab2b7d54941baf04acc40c8a7b.jpeg";